import { Component, computed, inject, model, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FORM_FIELD } from '@angular/forms/signals';

import { AssetService } from '../../../services/asset';
import { SpinnerLoaderDirective } from '../../directives/spinner-loader.directive';

@Component({
  selector: 'fs-asset-type-select',
  imports: [SpinnerLoaderDirective],
  templateUrl: './asset-type-select.html',
  styleUrl: './asset-type-select.scss',
})
export class AssetTypeSelect {
  private readonly assetService = inject(AssetService);
  protected readonly formField = inject(FORM_FIELD, { optional: true });
  
  readonly value = model<string>('');
  readonly touch = output<void>();
  readonly errors = computed(() => this.formField?.errors() ?? []);
  readonly isInvalid = computed(() => !!this.formField?.state().invalid() && !!this.formField?.state().touched());

  deviceType = toSignal(this.assetService.getDeviceTypes());

  onSelectionChange(event: Event) {
    const target = event.target as HTMLSelectElement;
    this.value.set(target.value);
    this.touch.emit();
  }

  onBlur() {
    this.touch.emit();
  }
}
